import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import OnboardingPageContentWrapper from "./onboardingPageContentWrapper/OnboardingPageContentWrapper"
import { BACKGROUND_COLORS } from "../../constants"
import useOnboardContext, {
  OnboardingStep,
} from "../../hooks/useOnboardContext"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { localStorageItems } from "../../util/storage"
import ChevronBackButton from "../buttons/ChevronBackButton"
import Primary3DButton from "../buttons/Primary3DButton"
import ParentAvatar from "../parentAvatar/ParentAvatar"
import TextInputRect from "../textInputRect/TextInputRect"

const OnboardParentNameSection = () => {
  const { parentData, setParentData, previousStep } = useOnboardContext()
  const [warningText, setWarningText] = useState("")
  const { setStep } = useOnboardContext()
  const { t } = useTranslation()

  const isCoparent = localStorage.getItem(localStorageItems.isCoparent)

  return (
    <OnboardingPageContentWrapper
      paddingTop="5dvh"
      style={{ position: "relative" }}
      backgroundOnDesktop={BACKGROUND_COLORS.lightBlueBg}
    >
      <ChevronBackButton onClick={previousStep} />
      <FlexBox direction="column" align="center" gap={SPACING.space6}>
        {parentData.avatar ? (
          <ParentAvatar avatar={parentData.avatar} className="rounded-full" />
        ) : (
          <img
            src="/images/parentDoterAssets/Placeholder_Ferox.png"
            alt="parent avatar"
            style={{ width: "100px", height: "100px", borderRadius: "100%" }}
          />
        )}
        <Typography variant="h2Serif" textAlign="center">
          {t("PARENT_NAME_TITLE")}
        </Typography>
        {!isCoparent && (
          <Typography
            variant="body"
            textAlign="center"
            style={{ width: "75%" }}
          >
            {t("PARENT_NAME_SUBTITLE")}
          </Typography>
        )}
        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="body">
            {t("PARENT_NAME_FIRST_NAME_LABEL")}
          </Typography>
          <TextInputRect
            fullWidth
            name="firstName"
            placeholder="Jane"
            onChange={(e: any) => setParentData("name", e.target.value)}
            value={parentData.name}
          />
        </FlexBox>
        <FlexBox direction="column" gap={SPACING.space1}>
          <Typography variant="body">
            {t("PARENT_NAME_LAST_NAME_LABEL")}{" "}
            <Typography variant="bodyXSmall" color={JoonUIColor.text.secondary}>
              {t("ONBOARDING_OPTIONAL")}
            </Typography>
          </Typography>
          <TextInputRect
            fullWidth
            name="lastName"
            placeholder="Doe"
            onChange={(e: any) => setParentData("lastName", e.target.value)}
            value={parentData.lastName || ""}
          />
        </FlexBox>
      </FlexBox>
      <FlexBox
        direction="column"
        gap={SPACING.space2}
        align="center"
        style={{ marginTop: SPACING.space4 }}
      >
        {warningText.length > 0 && (
          <Typography
            variant="bodySmallBold"
            color={JoonUIColor.semantic.alert}
          >
            {warningText}
          </Typography>
        )}
        <Primary3DButton
          text={t("ONBOARDING_CONTINUE")}
          fullWidth
          onClick={() => {
            if (parentData.name.length === 0) {
              setWarningText(t("PARENT_NAME_NAME_REQUIRED"))
            } else {
              trackAnalyticEvent(ANALYTIC_EVENTS.ADD_PARENT_NAME)
              setStep(OnboardingStep.ParentNicknameAvatar)
            }
          }}
        />
      </FlexBox>
    </OnboardingPageContentWrapper>
  )
}

export default OnboardParentNameSection
